module.exports = __webpack_public_path__ + "063d6900127ebd358555148417b104c4.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/logo-type.svg
 ** module id = 52
 ** module chunks = 0
 **/